import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa'; 

const React_Project = () => {
  const [expandedProject, setExpandedProject] = useState(null);

  const handleProjectClick = (projectName) => {
    if (expandedProject === projectName) {
      setExpandedProject(null);
    } else {
      setExpandedProject(projectName);
    }
  };

  return (
    <>
      <div className="parent-react-project">
          <div className="child-react-project" onClick={() => handleProjectClick('Project3')} title='click for more details'>
            <div className="sub-child-project">
              <img src="p3.png" alt="Project 2"></img>
            </div>
            <p>Online Examination Portal, Web</p>
            <h3>MSBTE</h3>
            <h4>Read More</h4>
          </div>
        <div className="child-react-project" onClick={() => handleProjectClick('Delightful Eats')} title='click for more details'>
          <div className="sub-child-project">
            <img src="p1.png" alt="Project 1"></img>
          </div>
          <p>Restaurant, Web</p>
          <h3>Delightful Eats</h3>
          <h4>Read More</h4>
        </div>
          <div className="child-react-project" onClick={() => handleProjectClick('Project2')} title='click for more details'>
            <div className="sub-child-project">
              <img src="p2.png" alt="Project 2"></img>
            </div>
            <p>Hotel, Web</p>
            <h3>The Palace of Prince</h3>
            <h4>Read More</h4>
          </div>
          <div className="child-react-project" onClick={() => handleProjectClick('Project4')} title='click for more details'>
            <div className="sub-child-project">
              <img src="p4.png" alt="Project 2"></img>
            </div>
            <p>Study Material, Web</p>
            <h3>Educational - MSBTE</h3>
            <h4>Read More</h4>
          </div>
      </div>
      {expandedProject && (
        <div className="expanded-details-overlay">
          <div className="expanded-details">
            <div className="close-icon" onClick={() => setExpandedProject(null)}>
              <FaTimes />
            </div>
            {expandedProject === 'Delightful Eats' && (
              <>
              <h2>Delightful Eats </h2>
              <div class="react-project-details">
                <div class="child-react-project-details">
                    <h3><span>Project : </span>Website</h3>
                    <h3><span>Languages : </span>React.js</h3>
                </div>
                <div class="child-react-project-details">
                    <h3><span>Preview :</span> <a className="" href="https://rest2.netlify.app/" target="_blank" rel="noopener noreferrer">https://rest2.netlify.app/</a></h3>
                </div>
              </div>
              <div class="child-react-project-details-1">
                <p>Welcome to Delightful Eats, a project built on React.js and founded by owner Prince Maurya. Our passion for exceptional food and warm hospitality ensures a memorable dining experience for all our guests.</p>
                <p>Experience the essence of Delightful Eats through our diverse menu offerings and inviting ambiance. Join us and discover what sets us apart - a commitment to quality cuisine and personalized service.</p>
                <img src="p1.png"></img>
                <img src="p1_1.png"></img>
                <img src="p1_2.png"></img>
              </div>
              </>
            )}
            {expandedProject === 'Project2' && (
              <>
              <h2>The Palace of Prince </h2>
              <div class="react-project-details">
                <div class="child-react-project-details">
                    <h3><span>Project : </span>Website</h3>
                    <h3><span>Languages : </span>React.js</h3>
                </div>
                <div class="child-react-project-details">
                    <h3><span>Preview :</span> <a className="" href="https://hotel99.netlify.app/" target="_blank" rel="noopener noreferrer">https://hotel99.netlify.app/</a></h3>
                </div>
              </div>
              <div class="child-react-project-details-1">
                <p>Welcome to Prince Hotel, where luxury meets comfort. Our project, built using React.js, offers an intuitive and seamless experience for booking rooms at our prestigious hotel.</p>
                <p>With our user-friendly interface, you can effortlessly browse through a variety of room options, each designed to cater to your specific needs and preferences. From elegant suites to cozy single rooms, we have accommodations to suit every traveler.</p>
                <p>Our advanced booking system ensures convenience and flexibility, allowing you to select your desired dates, room types, and amenities with ease. With real-time availability updates, you can book your stay with confidence, knowing that your chosen room is ready and waiting for your arrival.</p>
                <p>Experience the epitome of hospitality with Prince Hotel Rooms Booking, where every detail is crafted to exceed your expectations and make your stay truly unforgettable.</p>
                <img src="p2.png"></img>
                <img src="p2_1.png"></img>
                <img src="p2_2.png"></img>
              </div>
              </>
            )}
            {expandedProject === 'Project3' && (
              <>
              <h2>Online Examination Portal </h2>
              <div class="react-project-details">
                <div class="child-react-project-details">
                    <h3><span>Project : </span>Website</h3>
                    <h3><span>Languages : </span>React.js</h3>
                </div>
                <div class="child-react-project-details">
                    <h3><span>Preview :</span> <a className="" href="https://examinationportal.netlify.app/" target="_blank" rel="noopener noreferrer">https://examportal.netlify.app/</a></h3>
                </div>
              </div>
              <div class="child-react-project-details-1">
                <p>Welcome to the Examination Portal, a comprehensive platform meticulously crafted by Prince Maurya using React.js. This innovative solution offers a seamless experience for conducting online exams, managing results, generating hall tickets, accessing timetables, and facilitating administrative tasks. Students can effortlessly navigate through their dashboard to view exam schedules, download hall tickets, and check results. </p>
                <p>The platform ensures exam integrity through secure online exam conduct, with features such as timer-based exams and question shuffling. Detailed result reports are promptly displayed, enabling students to analyze their performance effectively. Hall tickets are automatically generated, and exam timetables are easily accessible for efficient exam planning. </p>
                <p>Administrators benefit from a robust admin panel, allowing them to manage exams, generate test codes, monitor attendance, and access administrative functionalities seamlessly. With the Examination Portal, Prince Maurya has created a user-centric solution that simplifies exam administration and enhances the overall examination experience.</p>
                <img src="p3.png"></img>
                <img src="p3_1.png"></img>
                <img src="p3_2.png"></img>
                <img src="p3_3.png"></img>
                <img src="p3_4.png"></img>
                <img src="p3_5.png"></img>
                <img src="p3_6.png"></img>
              </div>
              </>
            )}
            {expandedProject === 'Project4' && (
              <>
              <h2>The Palace of Prince </h2>
              <div class="react-project-details">
                <div class="child-react-project-details">
                    <h3><span>Project : </span>Website</h3>
                    <h3><span>Languages : </span>React.js</h3>
                </div>
                <div class="child-react-project-details">
                    <h3><span>Preview :</span> <a className="" href="https://modelanswer.netlify.app/" target="_blank" rel="noopener noreferrer">https://educational.netlify.app/</a></h3>
                </div>
              </div>
              <div class="child-react-project-details-1">
                <p>Welcome to the Study Material website, created by Prince Maurya. It's a place where students can find all the study materials they need for MSBTE exams in one convenient location. Whether it's model answers, question papers, syllabus details, or textbooks, everything is available here. It's easy to use, and students can quickly find what they're looking for to help them with their studies. Prince Maurya made this website to make it easier for students to succeed in their exams by giving them access to all the resources they need.</p>
                <img src="p4.png"></img>
                <img src="p4_1.png"></img>
                <img src="p4_2.png"></img>
              </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default React_Project;
